/* eslint-disable no-param-reassign */

import _ from 'underscore';
import { BaseSchemaProcessor } from './base-schema-processor';

const statusEnum = [
  "Enum.Status'Active'",
  "Enum.Status'Paused'",
  "Enum.Status'Creating'",
  "Enum.Status'Scheduled'",
  "Enum.Status'Ended'",
  "Enum.Status'CreationFailed'",
  "Enum.Status'Applying'",
  "Enum.Status'Applied'",
  "Enum.Status'ApplyFailed'",
];

const statusEnumValueMap = {
  "Enum.Status'Active'": 'Active',
  "Enum.Status'Applied'": 'Applied',
  "Enum.Status'ApplyFailed'": 'ApplyFailed',
  "Enum.Status'Applying'": 'Applying',
  "Enum.Status'Creating'": 'Creating',
  "Enum.Status'CreationFailed'": 'CreationFailed',
  "Enum.Status'Ended'": 'Ended',
  "Enum.Status'Paused'": 'Paused',
  "Enum.Status'Scheduled'": 'Scheduled',
};

export class ExperimentSchemaProcessor extends BaseSchemaProcessor {
  updateEntitySchemaForFeatures(entitySchema) {
    entitySchema.properties.Status.enum = statusEnum;
    entitySchema.properties.Status.enumValueMap = statusEnumValueMap;

    // Hide CampaignStatus and CampaignIsExperiment from filter menu.
    const campaignStatusProperty = entitySchema.properties.CampaignStatus;
    const campaignIsExperimentProperty = entitySchema.properties.CampaignIsExperiment;

    if (campaignStatusProperty) {
      campaignStatusProperty.filterable = false;
    }
    if (campaignIsExperimentProperty) {
      campaignIsExperimentProperty.filterable = false;
    }

    return entitySchema;
  }

  updateOdataOptions(odataOptions) {
    _.extendOwn(odataOptions.custom, {
      Status: {
        eq: (value) => {
          let url = `Status eq ${value}`;

          if (value === 'Enum.Status\'Applied\'') {
            url = 'Status eq Enum.Status\'Graduated\' or Status eq Enum.Status\'Promoted\'';
          }
          if (value === 'Enum.Status\'ApplyFailed\'') {
            url = 'Status eq Enum.Status\'GraduateFailed\' or Status eq Enum.Status\'PromoteFailed\'';
          }
          if (value === 'Enum.Status\'Applying\'') {
            url = 'Status eq Enum.Status\'Graduating\' or Status eq Enum.Status\'Promoting\'';
          }

          return url.replace(/Enum.Status/g, 'Enum.ExperimentStatus');
        },
      },
    });

    return odataOptions;
  }
}
